export * from '@fhs/routing/src/routes/(product)/menu/[slug]/index';
export { default } from '@fhs/routing/src/routes/(product)/menu/[slug]/index';
